import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader, Toggle } from "./_helpers";
import { toast } from "sonner";
import { GripVertical, ArrowUp, ArrowDown } from "lucide-react";

export default function AdminHomepage() {
  const [blocks, setBlocks] = useState([]);
  useEffect(() => { api.get("/homepage-blocks").then((r) => setBlocks(r.data.blocks || [])); }, []);
  const save = async () => {
    try { await api.put("/homepage-blocks", { blocks }); toast.success("Kaydedildi"); } catch { toast.error("Hata"); }
  };
  const move = (i, dir) => {
    const j = i + dir; if (j < 0 || j >= blocks.length) return;
    const arr = [...blocks]; const tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    arr.forEach((b, k) => b.sort_order = k + 1);
    setBlocks(arr);
  };
  const toggle = (i) => { const arr = [...blocks]; arr[i].is_active = !arr[i].is_active; setBlocks(arr); };
  return (
    <div>
      <AdminPageHeader title="Anasayfa Blokları" subtitle="Sıralama ve aktif/pasif yönetimi" action={<button onClick={save} className="px-4 py-2 bg-[#e11d2a] text-white rounded text-sm font-semibold">Kaydet</button>} />
      <div className="bg-white border border-gray-100 rounded-lg">
        {blocks.map((b, i) => (
          <div key={b.key} className="flex items-center justify-between px-4 py-3 border-b last:border-b-0">
            <div className="flex items-center gap-3">
              <GripVertical className="w-4 h-4 text-gray-300" />
              <span className="text-xs text-gray-400 w-6">#{b.sort_order}</span>
              <span className="font-medium">{b.label}</span>
              <span className="text-xs text-gray-400">{b.key}</span>
            </div>
            <div className="flex items-center gap-2">
              <Toggle label="Aktif" value={b.is_active} onChange={() => toggle(i)} />
              <button onClick={() => move(i, -1)} className="p-1 hover:bg-gray-100 rounded"><ArrowUp className="w-4 h-4" /></button>
              <button onClick={() => move(i, 1)} className="p-1 hover:bg-gray-100 rounded"><ArrowDown className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
